const { BASE_URL } = require("./client");

const GET_CAPITAL_OFFICE_DATA = BASE_URL + "/api/capitalofficeform";
const POST_CAPITAL_OFFICE_DATA = BASE_URL + "/api/capitalofficeform";
const UPDATE_CAPITAL_OFFICE_DATA = BASE_URL + "/api/capitalofficeform";
const DELETE_CAPITAL_OFFICE_DATA = BASE_URL + "/api/capitalofficeform";

module.exports = {
  GET_CAPITAL_OFFICE_DATA,
  POST_CAPITAL_OFFICE_DATA,
  UPDATE_CAPITAL_OFFICE_DATA,
  DELETE_CAPITAL_OFFICE_DATA,
};
